import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/leads/Index.vue')

export const leadsRoute: RouteConfig = {
  path: '/leads',
  name: 'leads',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体智云尊享版',
  },
}

export default [leadsRoute]
